import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  GET_VENDOR_MEMBER_COLUMNS_REQUEST,
  GET_VENDOR_USER_COLUMNS_REQUEST,
  SET_VENDOR_USER_COLUMNS_REQUEST,
} from "./type";
import {
  getVendorMemberColumnsSuccess,
  getVendorUserColumnsRequest,
  getVendorUserColumnsSuccess,
  setVendorUserColumnsSuccess,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";

function* getVendorMemberColumns() {
  try {
    const response = yield call(invokeApi, "get", "/vendorColumnsList");
    if (response.status) {
      yield put(getVendorMemberColumnsSuccess(response.data));
    } else {
      yield put(getVendorMemberColumnsSuccess(null));
      handleApiCallException(response.message);
    }
  } catch (error) {
    handleApiCallException(error);
  }
}

function* getVendorUserColumns({ payload: vendorId }) {
  try {
    const response = yield call(
      invokeApi,
      "get",
      `/vendorUserColumns/${vendorId}`
    );
    if (response.status) {
      yield put(getVendorUserColumnsSuccess(response.data));
    } else {
      yield put(getVendorUserColumnsSuccess(null));
      handleApiCallException(response.message);
    }
  } catch (error) {
    handleApiCallException(error);
  }
}

function* setVendorUserColumns({ payload: data }) {
  try {
    const response = yield call(invokeApi, "post", "/saveVendorUserColumns", {
      vendorId: data.vendorId,
      columnsSelected: data.columnsSelected,
    });
    if (response.status) {
      yield put(setVendorUserColumnsSuccess(response.data));
      ApiResponseMessage(response.message, SUCCESS);
      yield put(getVendorUserColumnsRequest(data.vendorId));
    } else {
      yield put(setVendorUserColumnsSuccess(response));
      ApiResponseMessage(response.message, DANGER);
      handleApiCallException(response.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    handleApiCallException(error);
  }
}

function* watchVendorMemberColumnsRequest() {
  yield takeLatest(GET_VENDOR_MEMBER_COLUMNS_REQUEST, getVendorMemberColumns);
  yield takeLatest(GET_VENDOR_USER_COLUMNS_REQUEST, getVendorUserColumns);
  yield takeLatest(SET_VENDOR_USER_COLUMNS_REQUEST, setVendorUserColumns);
}

function* VendorMemberColumnsSaga() {
  yield all([fork(watchVendorMemberColumnsRequest)]);
}

export default VendorMemberColumnsSaga;
